import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PatientAllergiesComponent } from '../patient-allergies/patient-allergies.component';

@Component({
  selector: 'app-patient-selected-allergies',
  templateUrl: './patient-selected-allergies.component.html',
  styleUrl: './patient-selected-allergies.component.scss'
})
export class PatientSelectedAllergiesComponent {

  protected includeOrUpdate: 'include' | 'update' = 'include';
  protected expanded: boolean = true;

  constructor(private dialog: MatDialog) { }

  openPopup() {
    this.dialog.open(PatientAllergiesComponent, {
      data: {
        includeOrUpdate: this.includeOrUpdate
      }
    })
      .afterClosed().subscribe()
  }
}
